<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-09-27 11:04:25
 * @LastEditTime: 2022-10-25 09:44:14
 * @LastEditors: chenguobiao
-->
<template>
  <div class="personal-info page-normal">
    <common-header ref="headerRef" selected="user" />
    <div class="page-normal__content">
      <div class="personal-info__info-box">
        <div class="title">
          <div class="left-main"><span class="line-bar"></span>个人信息</div>
          <common-back />
        </div>
        <el-form :model="formData" label-position="top">
          <div class="form-item-row">
            <el-form-item label="头像" class="avatar-form-item">
              <upload-img v-model="formData.avatarUrl" @input="handleInput" :url="formData.avatarUrl" />
            </el-form-item>
          </div>
          <div class="form-item-row">
            <el-form-item label="真实姓名" prop="name">
              <el-input v-model.trim="formData.name" disabled />
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-select v-model="formData.sex" disabled>
                <el-option label="男" :value="1" />
                <el-option label="女" :value="0" />
              </el-select>
              <div class="icon-edit" @click="handleClickEdit('sex')">
                <img src="@/render/assets/images/personal/edit.png">
              </div>
            </el-form-item>
            <el-form-item label="家长姓名" prop="parentName">
              <el-input v-model="formData.parentName" disabled/>
            </el-form-item>
            <el-form-item label="家长手机号" prop="parentPhone" class="mobile">
              <el-input v-model="formData.parentPhone" disabled/>
              <div class="icon-edit" @click="handleClickEdit('parentPhone')">
                <img src="@/render/assets/images/personal/edit.png">
              </div>
            </el-form-item>
          </div>
          <div class="form-item-row">
            <el-form-item label="证件类型" prop="cardTypeUid">
              <el-select v-model="formData.cardTypeUid" disabled placeholder="请选择证件类型">
                <el-option
                  v-for="identity in identityList"
                  :key="identity.uid"
                  :label="identity.name"
                  :value="identity.uid"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码" prop="card">
              <el-input v-model.trim="formData.card" disabled />
            </el-form-item>
            <el-form-item label="生日日期" prop="age">
              <el-input v-model="formData.age" disabled/>
            </el-form-item>
            <el-form-item label="学棋始于日期" prop="studyTime">
              <el-input v-model="formData.studyTime" disabled/>
            </el-form-item>
          </div>
          <div class="form-item-row">
            <el-form-item label="所在地区" prop="areaUid">
              <el-input v-model="cascaderCity" disabled/>
            </el-form-item>
            <el-form-item label="在读学校" prop="clubName">
              <el-input v-model.trim="clubName" disabled/>
            </el-form-item>
            <el-form-item label="在训机构" prop="organizationName">
              <el-input v-model.trim="organizationName" disabled/>
            </el-form-item>
            <el-form-item label="与选手关系" prop="relation">
              <el-input v-model="formData.relation" disabled />
            </el-form-item>
          </div>
          <div class="form-item-row">
            <el-form-item label="密码" prop="password" class="password">
              <el-input type="password" autocomplete="new-password" disabled v-model.trim="formData.comment"></el-input>
              <div class="icon-edit" @click="handleClickEdit('password')">
                <img src="@/render/assets/images/personal/edit.png">
              </div>
            </el-form-item>
             <el-form-item label="考级证书" prop="certificate" class="certificate">
              <a :href="certificateFile.certificateUrl" target="_blank" class="upload--certificate" v-for="(certificateFile, idx) in formData.certificateFileList" :key="idx">
                <div class="upload--certificate--icon">
                  <img src="@/render/assets/images/auth/icon-certificate.png">
                </div>
                <div class="upload--certificate--text">{{certificateFile.certificateUrl === formData.certificateUrl ? '过往证书' : ('国际象棋'+certificateFile.levelName+'级')}}</div>
              </a>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-dialog
        :visible.sync="dialogOptions.visible"
        :show-close="false"
        @close="handleClose">
        <div slot="title" class="dialog-title">
          <div class="left-title"><span class="line-bar"></span>{{dialogOptions.title}}</div>
          <div class="right-close" @click="handleClickClose">
            <img src="@/render/assets/images/personal/edit-close.png">
          </div>
        </div>
        <div class="dialog-body">
          <el-form :model="dialogOptions.formData" :rules="dialogOptions.rules" :hide-required-asterisk="true" ref="formRef" label-position="top">
            <template v-if="dialogOptions.type === 'password'">
              <!-- <el-form-item label="密码" prop="password" class="password">
                <el-input type="password" maxlength="16" autocomplete="new-password" placeholder="请输入密码" v-model.trim="formData.password"></el-input>
                <span class="security-level" ref="tip" style="display:none;color:#666;"><span ref="level"></span></span>
              </el-form-item> -->
              <el-form-item label="旧密码">
                <el-input type="password" placeholder="请输入旧密码" v-model="dialogOptions.formData.comment"></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPassword" class="password">
                <el-input type="password" maxlength="16" placeholder="请输入新密码" v-model.trim="dialogOptions.formData.newPassword"></el-input>
                <span class="security-level" ref="tip" style="display:none;color:#666;"><span ref="level"></span></span>
              </el-form-item>
              <el-form-item label="确认新密码" prop="confirmPassword">
                <el-input type="password" placeholder="请输入确认密码" v-model="dialogOptions.formData.confirmPassword"></el-input>
              </el-form-item>
            </template>
            <template v-else-if="dialogOptions.type === 'sex'">
              <el-form-item label="性别">
                <el-select v-model="dialogOptions.formData.sex">
                  <el-option label="男" :value="1" />
                  <el-option label="女" :value="0" />
                </el-select>
              </el-form-item>
            </template>
            <template v-else-if="dialogOptions.type === 'parentPhone'">
              <template v-if="dialogOptions.modifyStep === 1">
                <el-form-item label="家长手机号" prop="parentPhone" class="mobile">
                  <el-input v-model="dialogOptions.formData.parentPhone" disabled placeholder="请输入手机号" autocomplete="off"/>
                  <div class="send-message" @click="handleClickSendMessage">{{countDownTimes === 0 ? '获取验证码' : countDownTimes + 's'}}</div>
                </el-form-item>
                <el-form-item label="短信验证码" prop="code">
                  <el-input v-model="dialogOptions.formData.code"></el-input>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item label="家长手机号" prop="parentPhone" class="mobile">
                  <el-input v-model="dialogOptions.formData.parentPhone" placeholder="请输入新手机号" autocomplete="off"/>
                  <div class="send-message" @click="handleClickSendMessage">{{countDownTimes === 0 ? '获取验证码' : countDownTimes + 's'}}</div>
                </el-form-item>
                <el-form-item label="短信验证码" prop="code">
                  <el-input v-model="dialogOptions.formData.code"></el-input>
                </el-form-item>
              </template>
            </template>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
          <div class="confirm-button" @click="handleConfirm">
            <img :src="require(`@/render/assets/images/personal/${dialogOptions.type === 'parentPhone' && dialogOptions.modifyStep === 1 ? 'next-step' : 'edit-confirm'}.png`)">
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import store from 'store'
import { USER_INFO, COUNTDOWN } from '@/config/const'
import CommonHeader from '@/render/components/common/header'
import CommonBack from '@/render/components/common/back'
import uploadImg from '@/render/components/common/uploadImg'
import { deepClone, Timer } from '@/render/utils'
import { authAPI } from '@/apis'
let timer = null
const validate = {
  'PASSOWRD_REG_WEEK': /^[0-9]{6,8}$|^[A-Z]{6,8}$|^[a-z]{6,8}$|^[\W_!@#$%^&*`~()-+=]{6,8}$/,
  // eslint-disable-next-line no-control-regex
  'PASSOWRD_REG_MIDDLE': /^(?!\d+$)(?![a-zA-Z]+$)[\da-zA-Z]{8,10}$|^(?!\d+$)(?![\x00-\xff]+$)[\d\x00-\xff]{8,10}$|^(?!a-zA-Z+$)(?![\x00-\xff]+$)[a-zA-Z\x00-\xff]{8,10}$/,
  'PASSOWRD_REG_POWER': /^(?=.*[a-zA-Z])(?=.*[\W_!@#$%^&*`~()-+=])(?=.*\d)[^]{10,16}$|^(?=.*[a-zA-Z])(?=.*[\W_!@#$%^&*`~()-+=])[^]{10,16}$|^(?=.*\d)(?=.*[\W_!@#$%^&*`~()-+=])[^]{10,16}$|^(?=.*[a-zA-Z])(?=.*\d)[^]{10,16}$/
}

const validateMobile = (rule, value, callback) => {
  if (!value) {
    return new Error('请输入电话号码')
  } else {
    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
    const isPhone = reg.test(value)
    value = Number(value) // 转换为数字
    if (typeof value === 'number' && !isNaN(value)) { // 判断是否为数字
      value = value.toString() // 转换成字符串
      if (value.length < 0 || value.length > 12 || !isPhone) { // 判断是否为11位手机号
        callback(new Error('手机号码格式如:138xxxx8754'))
      } else {
        callback()
      }
    } else {
      callback(new Error('请输入电话号码'))
    }
  }
}
export default {
  name: 'PersonalInfo',
  data() {
    return {
      countDownTimes: 0,
      identityList: [],
      formData: {
      },
      dialogOptions: {
        visible: false,
        title: '',
        type: '',
        formData: {},
        modifyStep: 1,
        rules: {
        }
      }
    }
  },
  computed: {
    cascaderCity() {
      return `${this.formData.province||''}${this.formData.city||''}${this.formData.area||''}`
    },
    clubName() {
      return this.formData.clubName === '其它' ? "其他（"+(this.formData.otherClubName||"无")+"）" : this.formData.clubName
    },
    organizationName() {
      return this.formData.organizationName === '其它' ? "其他（"+(this.formData.otherOrganizationName||"无")+"）" : this.formData.organizationName
    }
  },
  components: {
    CommonHeader,
    CommonBack,
    uploadImg
  },
  mounted() {
    this.getIdentityList()
    this.getUser()
  },
  methods: {
    async getIdentityList() {
      const result = await authAPI.postGetListByCode({ code: 'certificates' })
      this.identityList = result.data
    },
    async getUser() {
      let { data } = await authAPI.postUserGetOne()
      delete data.password
      for (let key in data) {
        if (key === 'areaUid') {
          data[key] = data[key] == null ? '' : data[key]
        }
      }
      this.formData = data
      store.set(USER_INFO, data)
    },
    async handleInput(avatarUrl) {
      let submitFormData = deepClone(this.formData)
      submitFormData.avatarUrl = avatarUrl
      delete submitFormData.certificateFileList
      let result = await authAPI.postUserSave(submitFormData)
      if (result.code === 0) {
        this.$message.success('修改成功')
        await this.getUser()
        location.reload()
      }
    },
    handleBack() {
      this.$router.replace('/home')
    },
    handleClickEdit(type) {
      const validatePassConsistent = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.dialogOptions.formData.newPassword) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      const validatePassword = (rule, value, callback) => {
        if (value.length < 6 || value.length > 16) {
          this.$refs.tip.style.display = 'none'
          callback(new Error('密码位数为6位 ~ 16位'))
        } else if (value === '') {
          callback(new Error('请输入新密码'))
        } else if (validate.PASSOWRD_REG_WEEK.test(value)) {
          this.$refs.level.innerText = '弱，建议加强'
          this.$refs.tip.style.display = 'block'
          callback()
        } else if (validate.PASSOWRD_REG_MIDDLE.test(value)) {
          this.$refs.level.innerText = '中'
          this.$refs.tip.style.display = 'block'
          callback()
        } else if (validate.PASSOWRD_REG_POWER.test(value)) {
          this.$refs.level.innerText = '强'
          this.$refs.tip.style.display = 'block'
          callback()
        }
      }
      this.dialogOptions.visible = true
      this.dialogOptions.type = type
      switch (type) {
        case 'password':
          this.dialogOptions.title = '修改密码'
          this.dialogOptions.formData = {
            comment: '',
            newPassword: '',
            confirmPassword: ''
          }
          this.dialogOptions.rules = {
            comment: [],
            newPassword: [
              { validator: validatePassword }
            ],
            confirmPassword: [
              { validator: validatePassConsistent, trigger: 'blur' }
            ]
          }
          break
        case 'sex':
          this.dialogOptions.title = '修改性别'
          this.dialogOptions.formData = {
            sex: this.formData.sex
          }
          break
        case 'parentPhone':
          this.dialogOptions.title = '修改家长手机号'
          this.dialogOptions.formData = {
            parentPhone: this.formData.parentPhone,
            code: ''
          }
          this.dialogOptions.rules = {
            parentPhone: [
              { required: true, message: '请输入家长手机号', trigger: 'blur' },
              { validator: validateMobile, trigger: 'blur' }
            ],
            code: [
              { required: true, message: '请输入验证码', trigger: 'blur' }
            ]
          }
          break
      }
    },
    async handleClickSendMessage() {
      if (this.countDownTimes !== 0) return false
      try {
        if (this.dialogOptions.modifyStep == 1) {
          await authAPI.postSendSmsCode({phone: this.dialogOptions.formData.parentPhone, type: 3, loginName: this.formData.loginName})
        } else {
          await authAPI.postSendSmsCode({phone: this.dialogOptions.formData.parentPhone, type: 1})
        }
        this.countDownTimes = 60
        timer = new Timer(this.countDownTimes)
        timer.start(this.$bus, COUNTDOWN)
        this.$bus.on(COUNTDOWN, countDownTimes => {
          this.countDownTimes = countDownTimes
        })
      } catch (error) {
        throw error
      }
    },
    handleClickClose() {
      this.dialogOptions.visible = false
    },
    handleConfirm() {
      // this.dialogOptions.visible = false
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          const { formData, type } = this.dialogOptions
          let submitFormData = deepClone(this.formData)
          delete submitFormData.certificateFileList
          switch (type) {
            case 'password':
              if (formData.comment !== submitFormData.comment) {
                this.$message.error('旧密码不对，请重新输入')
                return
              }
              submitFormData.comment = formData.newPassword
              submitFormData.password = formData.newPassword
              break
            case 'sex':
              submitFormData.sex = formData.sex
              break
            case 'parentPhone':
              if (this.dialogOptions.modifyStep === 1) {
                await authAPI.postCheckSmsCode({phone: formData.parentPhone, loginName: submitFormData.loginName, type: 3, code: formData.code})
                timer && timer.stop()
                this.countDownTimes = 0
                this.dialogOptions.modifyStep = 2
                this.dialogOptions.formData = {
                  parentPhone: '',
                  code: ''
                }
                return;
              } else {
                await authAPI.postCheckSmsCode({phone: formData.parentPhone, type: 1, code: formData.code})
                submitFormData.parentPhone = formData.parentPhone
                submitFormData.code = formData.code
              }
              break
          }
          let result = await authAPI.postUserSave(submitFormData)
          if (result.code === 0) {
            this.$message.success('修改成功')
          }
          this.getUser()
          this.dialogOptions.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      timer && timer.stop()
      this.countDownTimes = 0
      this.dialogOptions = {
        ...this.dialogOptions,
        ...{
          title: '',
          type: '',
          modifyStep: 1,
          formData: {},
          rules: {
          }
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .personal-info {
    &__info-box {
      margin: val(77) auto 0;
      padding: val(66) val(106) 0;
      width: val(1500);
      height: val(800);
      background-color: #fff;
      box-shadow: 0px 13px 35px rgba(0, 0, 0, 0.14);
      border-radius: val(15);
      .title {
        display: flex;
        justify-content: space-between;
        margin-bottom: val(66);
        .left-main {
          display: flex;
          align-items: center;
          font-size: val(24);
          font-weight: 500;
          color: #4E2500;
          .line-bar {
            margin-right: val(5);
            width: val(6);
            height: val(16);
            background-color: #4E2500;
          }
        }
      }
      .form-item-row {
        display: flex;
        justify-content: space-between;
      }
    }
  }
</style>
<style lang="scss">
  .personal-info {
    &__info-box {
      position: relative;
    }
    .form-item-row {
      margin-bottom: val(30);
      .el-form-item {
        width: val(244);
        margin: 0;
        .el-form-item__content {
          line-height: unset;
          .icon-edit {
            cursor: pointer;
            position: absolute;
            width: val(13);
            right: val(9);
            bottom: val(9);
          }
        }
        .el-select {
          display: block;
          .el-input__prefix, .el-input__suffix {
            display: none;
          }
        }
        .el-icon-date {
          display: none;
        }

        .el-input {
          .el-input__inner {
            background-color: #fff;
            border: none;
            padding: 0;
            height: val(37);
            line-height: val(37);
            font-size: val(16);
            color: #111;
          }
        }
        .el-form-item__label {
          float: left;
          font-size: val(16);
          color: #5E3C00;
          line-height: 1em;
          vertical-align: unset;
          padding-bottom: val(12);
        }
        .el-form-item__content {
          border-bottom: 1px solid rgba(#B4BED7, 0.52);
        }
        .certificate--level {
          display: inline-block;
          width: 100%;
          &--text {
            font-size: val(16);
            color: #111;
            line-height: val(37);
          }
        }
        &.avatar-form-item {
          display: flex;
          align-items: center;
          .el-form-item__label {
            padding: 0;
            margin-right: val(20);
          }
          .el-form-item__content {
            border-bottom: none;
          }
          .avatar-uploader {
            .el-upload {
              display: block;
              border: 1px dashed rgba(#707070, 0.4);
              border-radius: 6px;
              cursor: pointer;
              position: relative;
              overflow: hidden;
              background: #F7F5EF;
            }
            .avatar-uploader-icon {
              font-size: 28px;
              color: #8c939d;
              width: val(82);
              height: val(82);
              line-height: val(82);
              text-align: center;
            }
            .avatar {
              width: val(82);
              height: val(82);
              display: block;
            }
          }
        }
        &.certificate {
          min-width: val(244);
          width: val(942);
          .el-form-item__content {
            float: left;
            width: 100%;
            border: none;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            // .certificate--image--list {
            //   display: flex;
            //   align-items: center;
            // }
            // .certificate--image {
            //   margin-right: val(10);
            //   width: val(120);
            //   height: val(80);
            //   border: 1px dashed #d9d9d9;
            //   border-radius: 6px;
            //   position: relative;
            //   overflow: hidden;
            //   img {
            //     width: 100%;
            //     height: 100%;
            //   }
            // }
            .upload--certificate {
              cursor: pointer;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-right: val(40);
              text-decoration: none;
              margin-bottom: 8px;
              &--icon {
                width: val(36);
                margin-bottom: val(8);
              }
              &--text {
                width: 100%;
                font-size: val(14);
                color: #5E3C00;
                line-height: val(14);
              }
            }
          }
        }
      }
    }
    .el-dialog {
      width: val(600);
      background: #FFFFFF;
      box-shadow: 0px val(13) val(35) rgba(0, 0, 0, 0.14);
      border-radius: val(15);
      .el-dialog__header {
        padding: val(30) val(34) val(49) val(30);
        .dialog-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left-title {
            display: flex;
            align-items: center;
            font-size: val(24);
            font-weight: 500;
            color: #4E2500;
            .line-bar {
              margin-right: val(5);
              width: val(6);
              height: val(16);
              background-color: #4E2500;
            }
          }
          .right-close {
            cursor: pointer;
            width: val(15);
          }
        }
      }
      .el-dialog__body {
        display: flex;
        justify-content: center;
        padding: 0;
        .el-form-item {
          width: val(244);
          margin: 0 0 val(30);
          &:last-of-type {
            margin: 0;
          }
          &.password {
            .el-form-item__content {
              position: relative;
              padding-right: val(50);
              .security-level {
                position: absolute;
                right: 0;
                bottom: 0;
                padding-bottom: val(10);
                padding-right: val(13);
                font-size: val(16);
              }
            }
          }
          &.mobile {
            .el-form-item__content {
              position: relative;
              padding-right: val(120);
              .send-message {
                width: val(106);
                cursor: pointer;
                position: absolute;
                right: 0;
                bottom: 0;
                padding: 0 0 val(10) val(13);
                font-size: val(16);
                color: #0077E8;
                box-sizing: border-box;
                &:before {
                  content: "";
                  position: absolute;
                  left: 0;
                  top: val(2);
                  width: 1px;
                  height: val(12);
                  background: #B4BED7;
                  opacity: 0.52;
                }
              }
            }
          }
          .el-select {
            display: block;
            .el-input__prefix, .el-input__suffix {
              top: val(12);
            }
          }
          .el-input {
            .el-input__inner {
              background-color: #fff;
              border: none;
              padding: 0;
              height: val(37);
              line-height: val(37);
              font-size: val(16);
              color: #111;
            }
          }
          .el-form-item__label {
            float: left;
            font-size: val(16);
            color: #5E3C00;
            line-height: 1em;
            vertical-align: unset;
            padding-bottom: val(12);
          }
          .el-form-item__content {
            border-bottom: 1px solid rgba(#B4BED7, 0.52);
            line-height: unset;
          }
        }
      }
      .el-dialog__footer {
        padding: val(50) 0;
        .dialog-footer {
          .confirm-button {
            cursor: pointer;
            margin: 0 auto;
            width: val(350);
          }
        }
      }
    }
  }
</style>
